import StreamService from '../../services/StreamService';

// Action Types
export const STREAM_ACTIONS = {
  // Fetch all streams
  FETCH_STREAMS_REQUEST: 'FETCH_STREAMS_REQUEST',
  FETCH_STREAMS_SUCCESS: 'FETCH_STREAMS_SUCCESS',
  FETCH_STREAMS_FAILURE: 'FETCH_STREAMS_FAILURE',
  
  // Fetch single stream
  FETCH_STREAM_REQUEST: 'FETCH_STREAM_REQUEST',
  FETCH_STREAM_SUCCESS: 'FETCH_STREAM_SUCCESS',
  FETCH_STREAM_FAILURE: 'FETCH_STREAM_FAILURE',
  
  // Create stream
  CREATE_STREAM_REQUEST: 'CREATE_STREAM_REQUEST',
  CREATE_STREAM_SUCCESS: 'CREATE_STREAM_SUCCESS',
  CREATE_STREAM_FAILURE: 'CREATE_STREAM_FAILURE',
  
  // Update stream
  UPDATE_STREAM_REQUEST: 'UPDATE_STREAM_REQUEST',
  UPDATE_STREAM_SUCCESS: 'UPDATE_STREAM_SUCCESS',
  UPDATE_STREAM_FAILURE: 'UPDATE_STREAM_FAILURE',
  
  // Delete stream
  DELETE_STREAM_REQUEST: 'DELETE_STREAM_REQUEST',
  DELETE_STREAM_SUCCESS: 'DELETE_STREAM_SUCCESS',
  DELETE_STREAM_FAILURE: 'DELETE_STREAM_FAILURE',
  
  // Regenerate stream key
  REGENERATE_KEY_REQUEST: 'REGENERATE_KEY_REQUEST',
  REGENERATE_KEY_SUCCESS: 'REGENERATE_KEY_SUCCESS',
  REGENERATE_KEY_FAILURE: 'REGENERATE_KEY_FAILURE',
  
  // Stream stats
  FETCH_STATS_REQUEST: 'FETCH_STATS_REQUEST',
  FETCH_STATS_SUCCESS: 'FETCH_STATS_SUCCESS',
  FETCH_STATS_FAILURE: 'FETCH_STATS_FAILURE',
  
  // Real-time updates
  UPDATE_STREAM_STATUS: 'UPDATE_STREAM_STATUS',
  SET_SELECTED_STREAM: 'SET_SELECTED_STREAM',
  CLEAR_STREAM_ERROR: 'CLEAR_STREAM_ERROR'
};

// Fetch all streams
export const fetchStreams = () => async (dispatch) => {
  dispatch({ type: STREAM_ACTIONS.FETCH_STREAMS_REQUEST });
  
  try {
    const response = await StreamService.getAllStreams();
    dispatch({
      type: STREAM_ACTIONS.FETCH_STREAMS_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    dispatch({
      type: STREAM_ACTIONS.FETCH_STREAMS_FAILURE,
      payload: error.message || 'Failed to fetch streams'
    });
  }
};

// Fetch stream statistics
export const fetchStreamStats = () => async (dispatch) => {
  dispatch({ type: STREAM_ACTIONS.FETCH_STATS_REQUEST });
  
  try {
    const response = await StreamService.getStreamStats();
    dispatch({
      type: STREAM_ACTIONS.FETCH_STATS_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    dispatch({
      type: STREAM_ACTIONS.FETCH_STATS_FAILURE,
      payload: error.message || 'Failed to fetch statistics'
    });
  }
};

// Fetch single stream
export const fetchStream = (id) => async (dispatch) => {
  dispatch({ type: STREAM_ACTIONS.FETCH_STREAM_REQUEST });
  
  try {
    const response = await StreamService.getStream(id);
    dispatch({
      type: STREAM_ACTIONS.FETCH_STREAM_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    dispatch({
      type: STREAM_ACTIONS.FETCH_STREAM_FAILURE,
      payload: error.message || 'Failed to fetch stream'
    });
  }
};

// Create new stream
export const createStream = (streamData, callback) => async (dispatch) => {
  dispatch({ type: STREAM_ACTIONS.CREATE_STREAM_REQUEST });
  
  try {
    const response = await StreamService.createStream(streamData);
    dispatch({
      type: STREAM_ACTIONS.CREATE_STREAM_SUCCESS,
      payload: response.data
    });
    
    // Refresh streams list
    dispatch(fetchStreams());
    dispatch(fetchStreamStats());
    
    if (callback) callback(null, response.data);
  } catch (error) {
    dispatch({
      type: STREAM_ACTIONS.CREATE_STREAM_FAILURE,
      payload: error.message || 'Failed to create stream'
    });
    if (callback) callback(error, null);
  }
};

// Update stream
export const updateStream = (id, updates, callback) => async (dispatch) => {
  dispatch({ type: STREAM_ACTIONS.UPDATE_STREAM_REQUEST });
  
  try {
    const response = await StreamService.updateStream(id, updates);
    dispatch({
      type: STREAM_ACTIONS.UPDATE_STREAM_SUCCESS,
      payload: { id, updates }
    });
    
    // Refresh streams list
    dispatch(fetchStreams());
    
    if (callback) callback(null, response.data);
  } catch (error) {
    dispatch({
      type: STREAM_ACTIONS.UPDATE_STREAM_FAILURE,
      payload: error.message || 'Failed to update stream'
    });
    if (callback) callback(error, null);
  }
};

// Delete stream
export const deleteStream = (id, callback) => async (dispatch) => {
  dispatch({ type: STREAM_ACTIONS.DELETE_STREAM_REQUEST });
  
  try {
    await StreamService.deleteStream(id);
    dispatch({
      type: STREAM_ACTIONS.DELETE_STREAM_SUCCESS,
      payload: id
    });
    
    // Refresh streams list and stats
    dispatch(fetchStreams());
    dispatch(fetchStreamStats());
    
    if (callback) callback(null);
  } catch (error) {
    dispatch({
      type: STREAM_ACTIONS.DELETE_STREAM_FAILURE,
      payload: error.message || 'Failed to delete stream'
    });
    if (callback) callback(error);
  }
};

// Set selected stream
export const setSelectedStream = (stream) => ({
  type: STREAM_ACTIONS.SET_SELECTED_STREAM,
  payload: stream
});

// Update stream status (real-time)
export const updateStreamStatus = (streamKey, status, metadata) => ({
  type: STREAM_ACTIONS.UPDATE_STREAM_STATUS,
  payload: { streamKey, status, metadata }
});

// Clear stream error
export const clearStreamError = () => ({
  type: STREAM_ACTIONS.CLEAR_STREAM_ERROR
});

// Regenerate stream key
export const regenerateStreamKey = (id, callback) => async (dispatch) => {
  dispatch({ type: STREAM_ACTIONS.REGENERATE_KEY_REQUEST });
  
  try {
    const response = await StreamService.regenerateKey(id);
    dispatch({
      type: STREAM_ACTIONS.REGENERATE_KEY_SUCCESS,
      payload: { id, stream_key: response.data.stream_key }
    });
    
    // Refresh streams list
    dispatch(fetchStreams());
    
    if (callback) callback(null, response.data);
  } catch (error) {
    dispatch({
      type: STREAM_ACTIONS.REGENERATE_KEY_FAILURE,
      payload: error.message || 'Failed to regenerate stream key'
    });
    if (callback) callback(error, null);
  }
};
